import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from './http.service';

import { SettingService } from './setting.service'; // 사용자 정의 상수
import { ToasterService } from './toaster.service';
import { SocketService } from './socket.service';
@Injectable()
export class AuthService {

    user: any;
    constructor(
        private router: Router,
        private settingService: SettingService,
        private http: HttpService,
        private toasterService: ToasterService,
        private socketService: SocketService
    ) { // , private app: App private navCtrl: NavController,

    }

    get navCtrl()  { // 서비스에서는 private navCtrl: NavController를 사용하면 에러가 발생한다.
        // return this.app.getActiveNav();
        return;
      }
    /**
     * 로그인 유무 체크
     */
    isLoggedIn() {
        if (!localStorage.getItem('authToken')) {
            return false;
        } else {
            this.user = JSON.parse(localStorage.getItem('me'));
            return this.user ? true : false;
        }
    }

    /**
     * 유효한 토큰인지 체크
     */
    validToken(callback: (body: any) => void) {
        this.http.get({url: 'validToken'}).then((response) => {
            if (response.code !== '000') { // if invalid session then delete current info
                localStorage.removeItem('authToken');
                localStorage.removeItem('me');
                localStorage.removeItem('gamegoal');
                callback(false);
            } else {
                callback(true);
            }
        });
    }

    loginById(paramsObj: any, callback: (body: any) => void) {
        const params = { mb_id: paramsObj.user_id, mb_password: paramsObj.password };
        this.http.post({url: 'auth', params}).then((obj) => {
            this.process_loginById(obj, callback);
        });
    }


    process_loginById(obj: any, callback: (body: any) => void) {
        if (obj.result === true) {
            try {
                localStorage.setItem('authToken', obj.token);
                localStorage.setItem('me', JSON.stringify(obj.user));
                this.socketService.setLogin();
            } catch (ex) {
                Storage.prototype._setItem = Storage.prototype.setItem;
                Storage.prototype.setItem = () => { };
                alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
            }
            this.settingService.init();
        } else {
            this.toasterService.showToaster('error', '인증에 실패하였습니다.');
        }

        callback(obj);
    }
    /**
     * 사용자 정보 가져오기
     */
    getUser() {
        if (!localStorage.getItem('authToken')) {
            return false;
        } else {
            return JSON.parse(localStorage.getItem('me'));
        }
    }

    /**
     * 로그인 확인(마이페이지등 반드시 로그인 해야 하는 곳에 설정)
     */
    mustLoggedIn() {

        if (this.isLoggedIn() === false) {
            this.router.navigateByUrl('/auth/login');
        } else {
            this.validToken(function(Bool) {
                if (Bool === false) {
                    this.router.navigateByUrl('/auth/login');
                }
            });
        }

    }
    /**
     * root Scope Refresh
     */
    refresh(callback: (body: any) => void) {
        this.http.get({url: 'auth/userinfo'}).then((obj) => {
            if (obj.result === true) {
                localStorage.setItem('me', JSON.stringify(obj.user));
                callback(obj.user);
            } else {
                console.log('auth refresh error:' + obj.message);
            }
        });
    }

    /*
     * 서버에 접근하여 현재 게임골을 가져온다.
     *

    set_goal(pick: string, callback: Function) {
        this.http.get({'url': 'mypage/get-current-goal?pick=' + pick}).then((obj) => {

        // this.rest.getapi({url: 'mypage/get-current-goal?pick=' + pick}, function(obj) {
            if (obj.result === true) {
                if (obj.data !== null) {
                    localStorage.setItem('gamegoal', JSON.stringify(obj.data));
                    // $rootScope.gamegoal    = JSON.parse(localStorage.getItem('gamegoal'));
                } else {
                    localStorage.setItem('gamegoal', null);
                }
            }

            if (typeof (callback) !== 'undefined') {
                callback(obj.data);
            }
        });
    }
    */
    /*
    * 단순히 로컬스토리지에서 데이타를 가져온다.(부하를 줄이기위해 디스플레이용으로 사용)

    getGoal () {
        if (!localStorage.getItem('authToken')) {
            return false;
        } else {
            const gamegoal = localStorage.getItem('gamegoal');
            if (!gamegoal || gamegoal === 'undefined') {
                return false;
            } else {
                return JSON.parse(gamegoal);
            }
        }

    }
    */
    logout() {
        localStorage.removeItem('authToken');
        localStorage.removeItem('me');
        localStorage.removeItem('gamegoal');
    }
    update(key: string, val: string) {
        const me = JSON.parse(localStorage.getItem('me'));
        switch (key) {
            case 'profile.thumbnail_image': me.profile.thumbnail_image = val; break;
            case 'profile.realname': me.profile.realname = val; break;
            case 'profile.dob': me.profile.dob = val; break;
            case 'profile.gender': me.profile.gender = val; break;
            case 'profile.phone': me.profile.phone = val; break;
            case 'profile.geo_location': me.profile.geo_location = val; break;
            case 'email': me.email = val; break;
            case 'username': me.username = val; break;

        }
        localStorage.setItem('me', JSON.stringify(me));
    }
}
